<template>
  <v-form enctype="multipart/form-data" ref="form" v-model="valid">
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <v-toolbar height="60" color="secondary" dark flat class="px-3">
        <v-icon left>mdi-truck-remove-outline</v-icon>
        <span class="text-h6 font-weight-medium">
          Enviar neumáticos instalados a SCRAP
        </span>
        <v-chip
          v-if="Item && Item.serieneumatico"
          color="white"
          text-color="secondary"
          class="font-weight-bold ml-3 px-3 elevation-1"
          style="font-size: 1.05rem; height: 36px"
        >
          <v-icon left size="20" color="secondary">mdi-barcode-scan</v-icon>
          Serie: {{ Item.serieneumatico }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'nuema_asig_scrap'"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2"
                >mdi-help-circle-outline</v-icon
              >
            </v-btn>
          </template>
          <span>Panel de ayuda</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="pa-5">
        <!-- SECCIÓN 1: Datos del Vehículo y Neumático -->
        <div class="mb-4">
          <div class="d-flex align-center mb-3">
            <v-icon small color="primary" class="mr-2"
              >mdi-truck-outline</v-icon
            >
            <span class="text-subtitle-1 font-weight-bold text--primary"
              >Datos del Vehículo y Neumático</span
            >
          </div>

          <v-row dense>
            <!-- Seleccionar Vehículo -->
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                :items="Vehiculos"
                @change="onSeleccionarVehiculo"
                v-model="Item.id_vehiculos"
                label="Seleccionar vehículo"
                outlined
                dense
                prepend-inner-icon="mdi-truck"
                hide-details="auto"
                :rules="[(v) => !!v || 'Vehículo es requerido']"
              ></v-autocomplete>
            </v-col>

            <!-- Seleccionar Neumático -->
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                :items="Neumaticos"
                @change="onSeleccionarNeumatico"
                v-model="Item.id_neumaticos"
                label="Seleccionar neumático"
                outlined
                dense
                prepend-inner-icon="mdi-tire"
                hide-details="auto"
                :rules="[(v) => !!v || 'Neumático es requerido']"
              ></v-autocomplete>
            </v-col>

            <!-- Km recorrido -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Km recorrido del vehículo"
                v-model="Item.km_recorridos"
                outlined
                dense
                suffix="km"
                prepend-inner-icon="mdi-speedometer"
                hide-details="auto"
                type="number"
                min="0"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined && v !== '') ||
                    'Km recorrido es requerido',
                ]"
                required
              ></v-text-field>
            </v-col>

            <!-- Motivo de Retiro -->
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                :items="MotivosRetiro"
                v-model="Item.motivo_retiro"
                label="Motivo de retiro"
                outlined
                dense
                prepend-inner-icon="mdi-swap-horizontal"
                hide-details="auto"
                :rules="[(v) => !!v || 'Motivo de retiro es requerido']"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- SECCIÓN 2: Datos del Retiro / Scrap -->
        <div class="mb-4">
          <div class="d-flex align-center mb-3">
            <v-icon small color="primary" class="mr-2"
              >mdi-clipboard-text-outline</v-icon
            >
            <span class="text-subtitle-1 font-weight-bold text--primary"
              >Datos del Retiro / Scrap</span
            >
          </div>

          <v-row dense>
            <!-- Fecha RETIRO/SCRAP -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                type="date"
                label="Fecha RETIRO/SCRAP"
                v-model="Item.fecha"
                outlined
                dense
                prepend-inner-icon="mdi-calendar"
                hide-details="auto"
                :rules="[(v) => !!v || 'Fecha de retiro es requerida']"
              ></v-text-field>
            </v-col>

            <!-- Motivo SCRAP con botón agregar -->
            <v-col cols="12" sm="6" md="3">
              <div class="d-flex align-center">
                <v-autocomplete
                  :items="MotivosScrap"
                  v-model="Item.motivo_scrap"
                  :menu-props="{ zIndex: 12 }"
                  label="Motivo SCRAP"
                  outlined
                  dense
                  prepend-inner-icon="mdi-alert-octagon-outline"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Motivo de scrap es requerido']"
                  class="mr-2"
                ></v-autocomplete>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      height="38"
                      width="38"
                      class="elevation-1 flex-shrink-0"
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="openModalMotivoScrap()"
                    >
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Nuevo motivo scrap</span>
                </v-tooltip>
              </div>
            </v-col>

            <!-- Remanente final -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Remanente final"
                v-model="Item.remanente_final"
                outlined
                dense
                suffix="mm"
                prepend-inner-icon="mdi-ruler"
                hide-details="auto"
                type="number"
                step="0.1"
                min="0"
              ></v-text-field>
            </v-col>

            <!-- Remanente límite -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Remanente límite"
                v-model="Item.remanente_limite"
                outlined
                dense
                suffix="mm"
                prepend-inner-icon="mdi-ruler-square"
                hide-details="auto"
                type="number"
                step="0.1"
                min="0"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined && v !== '') ||
                    'Remanente límite es requerido',
                ]"
                required
              ></v-text-field>
            </v-col>

            <!-- Textarea Recomendación -->
            <v-col cols="12" class="mt-2">
              <v-textarea
                label="Recomendación"
                v-model="Item.recomendacion"
                outlined
                dense
                rows="3"
                auto-grow
                counter="500"
                maxlength="500"
                clearable
                prepend-inner-icon="mdi-comment-text-outline"
                placeholder="Ingrese recomendaciones u observaciones técnicas sobre este neumático..."
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- SECCIÓN 3: Evidencias Fotográficas (3 Imágenes) -->
        <div>
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon small color="primary" class="mr-2"
                >mdi-camera-burst</v-icon
              >
              <span class="text-subtitle-1 font-weight-bold text--primary"
                >Evidencias Fotográficas</span
              >
            </div>
            <span
              class="text-caption grey--text text--darken-1 font-weight-medium"
            >
              Seleccione las imágenes; se subirán al presionar Guardar
            </span>
          </div>

          <v-row dense>
            <!-- IMAGEN 1 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-1"
                      >mdi-camera</v-icon
                    >
                    <span class="font-weight-bold text-caption">IMAGEN 1</span>
                  </div>
                  <v-chip
                    x-small
                    :color="previewLocal1 ? 'info' : 'grey lighten-2'"
                    :text-color="previewLocal1 ? 'white' : 'grey darken-2'"
                  >
                    {{ previewLocal1 ? "Por guardar" : "Sin imagen" }}
                  </v-chip>
                </div>

                <FileAgent
                  ref="fileAgent1"
                  :autoUpload="false"
                  @archivosubido="archivosubido1"
                  style="z-index: 0"
                />

                <div
                  class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                >
                  <template v-if="previewLocal1">
                    <img
                      :src="previewLocal1"
                      alt="Nueva Foto 1"
                      class="preview-img"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- IMAGEN 2 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-1"
                      >mdi-camera</v-icon
                    >
                    <span class="font-weight-bold text-caption">IMAGEN 2</span>
                  </div>
                  <v-chip
                    x-small
                    :color="previewLocal2 ? 'info' : 'grey lighten-2'"
                    :text-color="previewLocal2 ? 'white' : 'grey darken-2'"
                  >
                    {{ previewLocal2 ? "Por guardar" : "Sin imagen" }}
                  </v-chip>
                </div>

                <FileAgent
                  ref="fileAgent2"
                  :autoUpload="false"
                  @archivosubido="archivosubido2"
                  style="z-index: 0"
                />

                <div
                  class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                >
                  <template v-if="previewLocal2">
                    <img
                      :src="previewLocal2"
                      alt="Nueva Foto 2"
                      class="preview-img"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- IMAGEN 3 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-1"
                      >mdi-camera</v-icon
                    >
                    <span class="font-weight-bold text-caption">IMAGEN 3</span>
                  </div>
                  <v-chip
                    x-small
                    :color="previewLocal3 ? 'info' : 'grey lighten-2'"
                    :text-color="previewLocal3 ? 'white' : 'grey darken-2'"
                  >
                    {{ previewLocal3 ? "Por guardar" : "Sin imagen" }}
                  </v-chip>
                </div>

                <FileAgent
                  ref="fileAgent3"
                  :autoUpload="false"
                  @archivosubido="archivosubido3"
                  style="z-index: 0"
                />

                <div
                  class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                >
                  <template v-if="previewLocal3">
                    <img
                      :src="previewLocal3"
                      alt="Nueva Foto 3"
                      class="preview-img"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Footer Actions -->
      <v-card-actions class="pa-4 bg-actions">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid || guardando"
          :loading="guardando"
          color="info"
          class="px-6 text-capitalize font-weight-bold elevation-1"
          @click="agregar()"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Guardar en Scrap
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- MODAL ADD MOTIVO SCRAP -->
    <v-dialog
      v-model="dialogMotivoScrap"
      max-width="500px"
      @click:outside="cerrarDialogMotivoScrap"
    >
      <v-card class="rounded-lg">
        <v-toolbar height="50" color="primary" dark flat class="px-2">
          <v-icon left small>mdi-plus-circle</v-icon>
          <span class="text-subtitle-1 font-weight-medium"
            >Nuevo Motivo Scrap</span
          >
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarDialogMotivoScrap">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-container class="pa-0">
            <v-form ref="form_motivoscrap" v-model="validMotivo">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre del Motivo Scrap *"
                    outlined
                    dense
                    required
                    v-model="motivoscrap.motivo"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" class="red--text ml-2">
                  Motivo duplicado
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="!mostrarLabelDuplicado" class="grey--text"
            >*Indicador de campo requerido</small
          >
        </v-card-text>
        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarDialogMotivoScrap">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!validMotivo"
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click="addMotivoScrap(motivoscrap)"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FileAgent from "../FileAgent.vue";
import { axios2 as axios } from "@/interceptor/useApi";
import { notif } from "@/plugins/notyf";
import global from "@/global";

export default {
  components: {
    FileAgent,
  },
  props: ["dialog", "Item", "Vehiculos", "MotivosScrap"],
  data() {
    return {
      valid: false,
      validMotivo: false,
      guardando: false,
      global: global,
      MotivosRetiro: [
        {
          value: 1,
          text: "POR REENCAUCHE",
        },
        {
          value: 2,
          text: "POR REPARACIÓN",
        },
        {
          value: 3,
          text: "POR ROTACIÓN",
        },
        {
          value: 4,
          text: "POR DESGASTE FINAL",
        },
        {
          value: 5,
          text: "POR FALLA",
        },
      ],

      dialogMotivoScrap: false,
      motivoscrap: {},
      modal_form_motivoscrap: false,
      mostrarLabelDuplicado: false,
      descripcionRules: [(v) => !!v || "Descripción es requerido"],

      nuevaFoto1: null,
      nuevaFoto2: null,
      nuevaFoto3: null,
      previewLocal1: null,
      previewLocal2: null,
      previewLocal3: null,
    };
  },
  computed: {
    ...mapState("scrap", ["Neumaticos"]),
  },
  methods: {
    ...mapActions("scrap", [
      "cargarNeumaticosxVehiculo",
      "cargarNeumaticosScrap",
    ]),
    ...mapActions("motivosscrap", ["agregarMotivosScrap"]),

    limpiarArchivosLocales() {
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      this.nuevaFoto1 = null;
      this.nuevaFoto2 = null;
      this.nuevaFoto3 = null;
      this.previewLocal1 = null;
      this.previewLocal2 = null;
      this.previewLocal3 = null;
      if (this.$refs.fileAgent1) this.$refs.fileAgent1.reset();
      if (this.$refs.fileAgent2) this.$refs.fileAgent2.reset();
      if (this.$refs.fileAgent3) this.$refs.fileAgent3.reset();
    },

    archivosubido1: function ({ valor, fileRecords }) {
      this.nuevaFoto1 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.nuevaFoto1 && this.nuevaFoto1[0] && this.nuevaFoto1[0].file) {
        this.previewLocal1 = URL.createObjectURL(this.nuevaFoto1[0].file);
      } else {
        this.previewLocal1 = null;
      }
    },

    archivosubido2: function ({ valor, fileRecords }) {
      this.nuevaFoto2 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.nuevaFoto2 && this.nuevaFoto2[0] && this.nuevaFoto2[0].file) {
        this.previewLocal2 = URL.createObjectURL(this.nuevaFoto2[0].file);
      } else {
        this.previewLocal2 = null;
      }
    },

    archivosubido3: function ({ valor, fileRecords }) {
      this.nuevaFoto3 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      if (this.nuevaFoto3 && this.nuevaFoto3[0] && this.nuevaFoto3[0].file) {
        this.previewLocal3 = URL.createObjectURL(this.nuevaFoto3[0].file);
      } else {
        this.previewLocal3 = null;
      }
    },

    onSeleccionarVehiculo: async function (id) {
      await this.cargarNeumaticosxVehiculo(id);
    },

    onSeleccionarNeumatico: function (id) {
      if (id != null) {
        let neumatico = this.Neumaticos.find((el) => el.value == id);
        if (neumatico) {
          this.Item.remanente_limite = neumatico.remanente_limite;
          this.Item.serieneumatico = neumatico.text;
        }
      }
    },

    cerrarDialogo: function () {},

    openModalMotivoScrap: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarMotivoScrap();
      this.$nextTick().then(() => {
        this.modal_form_motivoscrap = true;
      });
      this.dialogMotivoScrap = true;
    },

    inicializarMotivoScrap: function () {
      this.motivoscrap = {
        motivo: null,
      };
    },

    cerrarDialogMotivoScrap() {
      this.dialogMotivoScrap = false;
      this.modal_form_motivoscrap = false;
      if (this.$refs.form_motivoscrap) this.$refs.form_motivoscrap.reset();
    },

    addMotivoScrap: async function (item) {
      if (
        !global.verificarDuplicados(
          this.MotivosScrap,
          item.motivo.toUpperCase(),
        )
      ) {
        let dato = await this.agregarMotivosScrap({
          url: "motivos/scrap",
          motivo: item.motivo.toUpperCase(),
        });
        this.MotivosScrap.push({
          value: dato.id,
          text: dato.motivo,
        });
        this.dialogMotivoScrap = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    async subirFoto(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("imagen/subirimagen", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return typeof res.data === "string"
        ? res.data
        : res.data?.data || res.data?.nombre || "";
    },

    agregar: async function () {
      try {
        if (
          this.Item.remanente_final == null ||
          this.Item.remanente_final === ""
        ) {
          this.Item.remanente_final = 0;
        }

        if (this.$refs.form.validate()) {
          this.guardando = true;

          // 1. Subir Foto 1 si hay archivo seleccionado
          if (
            this.nuevaFoto1 &&
            this.nuevaFoto1.length > 0 &&
            this.nuevaFoto1[0].file
          ) {
            const nombre1 = await this.subirFoto(this.nuevaFoto1[0].file);
            if (nombre1) {
              this.Item.ruta1 = [{ upload: { data: nombre1 } }];
              this.Item.neumaticoimg1 = nombre1;
              this.Item.neumaticoimgruta1 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre1;
            }
          }

          // 2. Subir Foto 2 si hay archivo seleccionado
          if (
            this.nuevaFoto2 &&
            this.nuevaFoto2.length > 0 &&
            this.nuevaFoto2[0].file
          ) {
            const nombre2 = await this.subirFoto(this.nuevaFoto2[0].file);
            if (nombre2) {
              this.Item.ruta2 = [{ upload: { data: nombre2 } }];
              this.Item.neumaticoimg2 = nombre2;
              this.Item.neumaticoimgruta2 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre2;
            }
          }

          // 3. Subir Foto 3 si hay archivo seleccionado
          if (
            this.nuevaFoto3 &&
            this.nuevaFoto3.length > 0 &&
            this.nuevaFoto3[0].file
          ) {
            const nombre3 = await this.subirFoto(this.nuevaFoto3[0].file);
            if (nombre3) {
              this.Item.ruta3 = [{ upload: { data: nombre3 } }];
              this.Item.neumaticoimg3 = nombre3;
              this.Item.neumaticoimgruta3 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre3;
            }
          }

          const url = "scrap/store";
          const data = {
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            neumatico: this.Item,
          };
          await axios
            .post(url, data)
            .then(async (response) => {
              notif.success("Operación realizada con éxito");
              this.limpiarArchivosLocales();
              try {
                if (this.cargarNeumaticosScrap) {
                  await this.cargarNeumaticosScrap();
                }
              } catch (e) {
                console.warn("No se pudo recargar scrap store:", e);
              }
              if (this.$refs.form) this.$refs.form.reset();
              this.$emit("guardado");
            })
            .catch((error) => {
              this.errorMessage = error.response
                ? error.response.data
                : error.message;
              console.error("error!", error);
              notif.error("Error al registrar en scrap");
            })
            .finally(() => {
              this.guardando = false;
            });
        }
      } catch (error) {
        console.log(error);
        notif.error("Error al procesar la información");
        this.guardando = false;
      }
    },
  },
  beforeDestroy() {
    this.limpiarArchivosLocales();
  },
};
</script>

<style scoped>
.photo-card {
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  transition: all 0.2s ease-in-out;
}
.photo-card:hover {
  border-color: #94a3b8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.preview-box {
  min-height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  overflow: hidden;
  padding: 6px;
}
.preview-img {
  width: 100%;
  max-height: 210px;
  object-fit: contain;
  border-radius: 6px;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.bg-actions {
  background-color: #f8fafc;
}
.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}
.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}
.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
